import {Role} from "../../types/Role";

export const ROLE_TYPES: Role['type'][] = ["user", "driver", "admin"]